import React, { useState, useRef } from 'react';
import {
  focusEditor,
  useEventPlateId,
  usePlateEditorState,
  setElements,
  getPluginType,
  getListItemEntry,
  isBlock,
  toggleList,
  ELEMENT_UL,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ToolbarDropdown, { ToolbarDropdownButton } from './ToolbarDropdown';
import { BlockToolbarButton } from '../button/BlockToolbarButton';

import './list-dropdown.scss';

export const ListDropdown = ({ id, ...props }) => {

  const [open, setOpen] = useState(false);
  const ref = useRef();

  const editor = usePlateEditorState(useEventPlateId(id));

  const res = !!editor?.selection && getListItemEntry(editor);

  const show = () => {
    setOpen(true);
  };

  const dismiss = () => {
    setOpen(false);
  };

  const setListType = (e, style) => {
    if (!res || res.list[0].type !== ELEMENT_UL) {
      toggleList(editor, { type: getPluginType(editor, ELEMENT_UL) });
    }

    e.stopPropagation();
    e.preventDefault();

    const match = (n) => {
      return (
        isBlock(editor, n) &&
        n.type === ELEMENT_UL
      );
    };
    setElements(
      editor,
      { listStyleType: style },
      { match },
    );
    focusEditor(editor);
    dismiss();
  };

  const trigger = (
    <ToolbarDropdownButton
      className="button--unstyled toolbar-dropdown__button"
    >
      <FontAwesomeIcon
        icon={['fal', 'chevron-down']}
        size="xs"
      />
    </ToolbarDropdownButton>
  );

  return (
    <div
      ref={ref}
      className="plate-dropdown-button-combo"
    >
      <BlockToolbarButton
        name="Bulleted list"
        active={!!res && res.list[0].type === ELEMENT_UL}
        type={ELEMENT_UL}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          toggleList(editor, { type: getPluginType(editor, ELEMENT_UL) });
          focusEditor(editor);
        }}
        icon={<FontAwesomeIcon icon={['fa', 'list-ul']} />}
        {...props}
      />
      <ToolbarDropdown
        isOpen={open}
        show={show}
        dismiss={dismiss}
        DropdownButton={trigger}
        name="list-dropdown"
        className="plate-toolbar__dropdown-button list-dropdown"
        root={null}
        anchorElement={ref?.current}
      >
        <button
          className="button--unstyled button--editor-menu"
          onClick={(e) => setListType(e, 'disc')}
        >
          <ul className="slate-ul slate-ul--disc"><li>Disc</li></ul>
        </button>
        <button
          className="button--unstyled button--editor-menu"
          onClick={(e) => setListType(e, 'circle')}
        >
          <ul className="slate-ul slate-ul--circle"><li>Circle</li></ul>
        </button>
        <button
          className="button--unstyled button--editor-menu"
          onClick={(e) => setListType(e, 'square')}
        >
          <ul className="slate-ul slate-ul--square"><li>Square</li></ul>
        </button>
        <button
          className="button--unstyled button--editor-menu"
          onClick={(e) => setListType(e, 'dash')}
        >
          <ul className="slate-ul slate-ul--dash"><li>Dash</li></ul>
        </button>
      </ToolbarDropdown>
    </div>

  );
};
